module.exports = __webpack_public_path__ + "img/浦东新区企业研发机构.6e50ad3a.jpg";